<template>
    <div class="EquipmentElectricity" >
        <Title firstName="本月能耗排名" lastName="ENERGY CONSUMPTION RANKING"/>
        <div class="echarts">
            <!-- <div class="over">
                <div class="tag">
                    <span :class="{active:acindex==0}" @click="changeIdx(0)">日</span>
                    <span :class="{active:acindex==1}" @click="changeIdx(1)">月</span>
                </div>
            </div> -->
           <div class="floor">
                <div class="warp">
                    <div class="item" v-for="item in sortArr[acindex]" :key="item.id">
                        <div class="title">{{item.title}}</div>
                        <div class="progress" :style="item.ratioStyle">
                            <div class="warp1">
                                <span >{{item.val}}kWh</span>
                            </div>
                        </div>
                        
                    </div>
                </div>
           </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../../components/title/Title')
const Graph = () => import('../../../../components/echarts/graph.vue')
const charts = () => import('../../../../components/echarts/charts.vue')
const SelectList = () => import('../../../../components/title/selectList.vue')
export default {
    props:{
        sortArr:{
            type:Array,
            default:[]
        }
    },
    data(){
        return {
            acindex:1,
            rankList:[
                {
                    title:"主楼1F",
                    id:1,
                    ratioStyle:{
                        width:'100%' ,
                        background: '#5B8FF9'
                    },
                    val:6201
                },
                {
                    title:"主楼2F",
                    id:2,
                    ratioStyle:{
                        width:'70%' ,
                        background: '#F6BD16'
                    },
                    val:4311
                },
                {
                    title:"主楼3F",
                    id:3,
                    ratioStyle:{
                        width:'50%' ,
                        background: '#FF9D4D'
                    },
                    val:3155
                },
                {
                    title:"主楼4F",
                    id:4,
                    ratioStyle:{
                        width:'30%' ,
                        background: '#DCDCDC'
                    },
                    val:2000
                },
                {
                    title:"主楼5F",
                    id:5,
                    ratioStyle:{
                        width:'15%' ,
                        background: '#00E5EE'
                    },
                    val:1550
                },
                {
                    title:"主楼6F",
                    id:6,
                    ratioStyle:{
                        width:'5%' ,
                        background: '#54FF9F'
                    },
                    val:315
                },
                {
                    title:"主楼7F",
                    id:7,
                    ratioStyle:{
                        width:'1%' ,
                        background: '#87CEFA'
                    },
                    val:31
                },
            ]
        }
    },
    components:{
        Title,Graph,charts,SelectList
    },
    mounted(){
        
    },
    methods:{
        changeIdx(idx){
            this.acindex = idx
        }
    },
}
</script>

<style lang="less" scoped>
    .EquipmentElectricity{
        // height: 33.3vh;
        width: 20vw;
        // height: 493rem;
        position: fixed;
        top: 69.5vh;
        left: 2vw;
        z-index: 1;

        .echarts{
            position: relative;
            height: 23.5vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);
            overflow: hidden;
            padding-left: 0.5vw;
            
            .over{
                display: block;
                text-align: right;
            }
            .floor{
                margin-top: 0.5vh;
                padding:0 30rem;
                height: 22vh;
                overflow-x: hidden;
                overflow-y:scroll ;
                direction: rtl;
                .warp{
                    direction: ltr;
                }
                .item{
                    color: rgba(230, 243, 253, 0.7);
                    font-size: 16rem;
                    margin:20rem 0;
                    .title{
                        margin-bottom: 5rem;
                    }
                    
                    .progress{
                        width: 100%;
                        height: 1vh;
                        border-radius: 8rem;
                        .warp1{
                            position: relative;
                            min-width: 10vw;
                        }
                        span{
                            display: inline-block;
                            position: absolute;
                            top:-28rem;
                            right: 0;
                            color:rgba(0, 222, 255, 0.7);
                            font-size: 22rem;
                            font-family: zcoolqingkehuangyouti;
                        }
                    }
                }
            }
            .floor::-webkit-scrollbar{
                width: 8rem;
            }
            .floor::-webkit-scrollbar-thumb{
                background: rgba(52,141,240, 0.4);
                border: 1px solid #348DF0;
                border-radius: 5rem;
            }
            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }
    }
</style>